// extracted by mini-css-extract-plugin
export default {"newTokenDisplay":"wHM6ZKy0lM_SKViTabeA","tokenLabel":"qYKbd_pRCJyqNPyx_SsY","confirmButton":"cVS_3fCnYLiwKCH5bnJp"};